// ABOUTME: Loading state of the auth screens — spinner with a caption, and its standalone screen.
// ABOUTME: The frame is separate because the /auth/* routes already wrap their pages in AuthLayout.

import { useTranslation } from "react-i18next"
import { CSpinnerInline } from "@shared/ui"
import { AuthLayout } from "./AuthLayout"

interface AuthLoadingProps {
  /** What we are waiting for. Defaults to the session check. */
  note?: string
}

/**
 * Content only — use inside an existing AuthLayout (that is what every /auth/* page has:
 * the route provides the layout, the page renders the card or this).
 */
export const AuthLoading = ({ note }: AuthLoadingProps) => {
  const { t } = useTranslation()

  return (
    // 24px between the spinner and its caption (docs/design/Загрузка.dc.html, stage 2). The gap
    // ABOVE the spinner stays the layout's 28px, which the auth cards also use: the logo then
    // holds still when the card replaces the spinner, instead of hopping 4px.
    <div className="flex flex-col items-center gap-6">
      <CSpinnerInline
        loading
        size="xl"
        className="h-9 w-9 text-primary"
      />
      <p className="text-sm text-gray-400 max-sm:text-gray-500">{note ?? t("auth.checkingSession")}</p>
    </div>
  )
}

/**
 * The same wait with the auth frame around it — backdrop and logo included. For places that
 * are NOT inside a layout already: /logout, the post-login gate, the redirect legs.
 */
export const AuthLoadingScreen = ({ note }: AuthLoadingProps) => (
  <AuthLayout>
    <AuthLoading note={note} />
  </AuthLayout>
)
